'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linksLocal = require('./links.local.css');

var _linksLocal2 = _interopRequireDefault(_linksLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Links = function Links(_ref) {
  var links = _ref.links,
      Link = _ref.Link;
  return _react2.default.createElement('ul', {
    className: _linksLocal2.default.linksList
  }, links.reduce(function (acc, link) {
    return acc.concat(_react2.default.createElement('li', {
      key: link.to
    }, _react2.default.createElement(Link, {
      to: link.to,
      className: _linksLocal2.default.link
    }, link.label)));
  }, []));
};

Links.propTypes = {
  /**
   * Link from react-router
   */
  Link: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node, _propTypes2.default.element]).isRequired,

  /**
   * Array of links to show
   */
  links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    to: _propTypes2.default.string,
    label: _propTypes2.default.string
  })).isRequired
};
exports.default = Links;